module.exports = __webpack_public_path__ + "img/bd.0f3c431a.png";